import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/security/auth';
import user from './modules/security/user';
import account from './modules/security/account';
import security from './modules/security/security';
import environment from './modules/general/environment';
import ticket from './modules/helpdesk/ticket';
import attendance from './modules/attendance/attendance';
import shifts from './modules/attendance/shifts';
import companies from './modules/company/companies';
import leaves from './modules/leaves/leaves';
import machines from './modules/attendance/machines';
import employees from './modules/attendance/employees';
import branches from './modules/company/branches';
import departments from './modules/company/departments';
import designations from './modules/company/designations';
import holidays from './modules/company/holidays';
import leave_types from './modules/leaves/leave_types';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth, user, account, security, environment, ticket, attendance, shifts, companies, leaves,
    machines, employees, branches, departments, designations, holidays, leave_types
  }
});


// WEBPACK FOOTER //
// ./src/store/store.js